import React, {Component} from "react"
import styled from "styled-components"

import idHelper from "@irati/utils/id"
import authentication from "@irati/auth"
import {PriceInput} from "@irati/ui/src/FormItem"

interface Props {
  amount: string
  id: string
  updateAmount(amount: string): void
  name: string
  label: string
}

const StyledDiv = styled.div`
  display: flex;
  .perkboxInput {
    width: 100%;
  }
  .col-xs-12 {
    padding: 0;
  }
`

class TenantWalletTransferAmount extends Component<Props> {
  render() {
    const currency = authentication.defaultUserCurrency()
    const {amount, updateAmount, name, label} = this.props

    return (
      <StyledDiv>
        <PriceInput
          currency={currency}
          id={idHelper("TenantWalletAmount", this.props)}
          label={label}
          min="1.00"
          name={name}
          onChange={updateAmount}
          step="0.01"
          value={amount}
        />
      </StyledDiv>
    )
  }
}

export default TenantWalletTransferAmount
